import { CSSProperties } from 'react';

interface DialogStyles {
  paper: CSSProperties;
  content: CSSProperties;
  actions: CSSProperties;
  title: CSSProperties;
  errorMessage: CSSProperties;
}

export const dialogStyles: DialogStyles = {
  paper: {
    minHeight: '60vh',
    maxHeight: '65vh',
    borderRadius: 15,
  },
  content: {
    padding: '10px'
  },
  actions: {
    padding: 20
  },
  title: {
    padding: '10px',
    textAlign: 'center' as const,
    paddingTop: '25px'
  },
  errorMessage: {
    color: 'red',
    fontSize: '0.8rem',
    paddingLeft: '20px'
  }
}; 